const imageQuality = 75;

export default imageQuality;
